import React, { useState } from "react";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Grid,
  Button,
} from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import TextareaAutosize from '@mui/base/TextareaAutosize';
import { palette, useStylesGlobal } from "configurations/styles/theme";
import { useSnackbar } from "notistack";
import { useStylesApp } from "hooks/useStyles";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import { validationComercialOrderInvoice } from "./Validations/validationsForms";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginBottom: "0.5%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightRegular,
    color: palette.primary.menuHeader,
  },
  accordionSumary: {
    backgroundColor: palette.primary.light,
  },
  margin: {
    margin: theme.spacing(0),
    width: "100%",
    marginBottom: "1%",
  },
}));

export default function ComercialOrderInvoice({
  informacionComercial,
  setInformacionComercial,
}) {
  const classes = useStyles();
  const classesGlobal = useStylesGlobal();
  const classesApp = useStylesApp();
  const { enqueueSnackbar } = useSnackbar();
  const [open, setOpen] = useState(false);
  const [errors, setErrors] = useState({});
  // const [informacionComercial, setInformacionComercial] = useState({});
  const [numeroAceptacion, setNumeroAceptacion] = useState();
  const [arrNroAceptacion, setArrNroAceptacion] = useState([]);

  const handleChange = (event) => {
    setInformacionComercial({
      ...informacionComercial,
      [event.target.name]: event.target.value,
    });
  };
  
  const handleAddNumberAcceptance = (event) => {
    let numeros = event.target.value;
    let arrayNumeros = numeros.split(",");
    setInformacionComercial({
      ...informacionComercial,
      nroAceptacion: arrayNumeros,
    });
  };
  const validateComercialOrder = (data) => {
    let newErrors = validationComercialOrderInvoice.onSubmit({
      nroPedidoCompra: data.nroPedidoCompra,
      codigoCliente: data.codigoCliente,
      informacionInteres: data.informacionInteres,
      nroAceptacion: data.nroAceptacion,
    });
    if (Object.entries(newErrors).length > 0) {
      setErrors(newErrors);
      return false;
    } else {
      return true;
    }
  };

  const handleClickOpen = () => {
    if (open) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  };

  const handleClickAdd = () => {
    if (validateComercialOrder(informacionComercial)) {
      enqueueSnackbar(`Información comercial agregada al comprobante`, {
        variant: "success",
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        autoHideDuration: 4000,
      });
      setErrors({});
    } else {
      setInformacionComercial({});
    }
  };

  return (
    <div className={classes.root}>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
          onClick={handleClickOpen}
        >
          <label className={classesGlobal.titleCard}>
            Información del pedido comercial relacionada con la factura:{" "}
          </label>
          <label className={classesGlobal.click}>
            <label> </label> (Clic Aquí)
          </label>
        </AccordionSummary>
        <AccordionDetails>
          <from style={{ width: "100%" }}>
            <Grid
              container
              xs={12}
              md={12}
              direction="row"
              justifyContent="center"
              alignItems="center"
              spacing={1}
            >
              <Grid item xs={12} md={2}>
                <label>Número del pedido de compra:</label>{" "}
                <font color={palette.error.main}>*</font>
              </Grid>
              <Grid item xs={12} md={4}>
                <input
                  type="string"
                  className="form-control"
                  name="nroPedidoCompra"
                  value={informacionComercial.nroPedidoCompra}
                  onChange={handleChange}
                />
                {errors.nroPedidoCompra ? (
                  <p className={classesApp.errorLetters}>
                    {errors.nroPedidoCompra}
                  </p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={2}>
                <label>Código de cliente/receptor:</label>
              </Grid>
              <Grid item xs={12} md={4}>
                <input
                  type="string"
                  className="form-control"
                  name="codigoCliente"
                  value={informacionComercial.codigoCliente}
                  onChange={handleChange}
                />
                {errors.codigoCliente ? (
                  <p className={classesApp.errorLetters}>
                    {errors.codigoCliente}
                  </p>
                ) : null}
              </Grid>

              <Grid item xs={12} md={2}>
                <label>Información adicional:</label>
              </Grid>
              <Grid item xs={12} md={4}>
                <TextareaAutosize
                  minRows={3}
                  type="string"
                  className="form-control"
                  name="informacionInteres"
                  value={informacionComercial.informacionInteres}
                  onChange={handleChange}
                />
                {errors.informacionInteres ? (
                  <p className={classesApp.errorLetters}>
                    {errors.informacionInteres}
                  </p>
                ) : null}
              </Grid>
              <Grid item xs={12} md={2}>
                <label>Número de aceptación:</label>
              </Grid>
              <Grid item xs={12} md={4}>
                <textarea
                  className="form-control"
                  type="string"
                  name="nroAceptacion"
                  rows="3"
                  cols="50"
                  value={numeroAceptacion}
                  onChange={handleAddNumberAcceptance}
                />
                <small style={{ color: "#818181" }}>
                  Agregue los números de aceptación separado por comas (Ej.
                  12,23,54)
                </small>
                {/* {errors.nroAceptacion ? (
                                    <p className={classesApp.errorLetters}>
                                        {errors.nroAceptacion}
                                    </p>
                                ) : null} */}
              </Grid>
            </Grid>
          </from>
          <Button variant="outlined" color="primary" onClick={handleClickAdd}>
            Agregar información del pedido comercial
          </Button>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
